import Cookies from "js-cookie";

export default async function ({ $auth, app, redirect, route, query }) {
    const ALLOW_ROUTES = [
        "/lk/login/",
        "/lk/register/",
        "/lk/recover/",
        "/lk/reset/",
        "/lk/login-offline/aviapark/",
        "/lk/login-offline/tsvetnoy/",
        "/lk/login-offline/avenue/",
        "/lk/login-offline/bolshoi/",
    ];
    if ($auth.loggedIn) {
        // если авторизованы то не пускаем на регистрацию логин

        if (query.redirect) {
            return redirect(`/${query.redirect}/`);
        }

        if (ALLOW_ROUTES.includes(route.path)) {
            return redirect("/lk/");
        }
    } else {
        // если не авторизованы то не пускаем никуда кроме разрешенных путей
        if (query.offline_code) {
            try {
                const { data } = await app.$axios.post(
                    "/api/auth/offline/exchange",
                    `offline_code=${query.offline_code}`,
                    { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
                );

                if (data.success && data.token) {
                    try {
                        await app.$axios.get("/api/auth/xsrf_token");

                        await $auth.loginWith("cookie", { data: { token: data.token } });
                    } catch (error) {
                        console.log(`error.response =>`, JSON.stringify(error.response?.data));
                        console.log(`$auth.loginWith("cookie") =>`, error.response?.data?.message || error);
                    }

                    // try {
                    //     const res2 = await app.$axios.post("/api/auth/login", { token: data.token });
                    //     console.log(`res2 =>`, res2);
                    // } catch (error) {
                    //     console.log(`error.response =>`, JSON.stringify(error.response?.data));
                    //     console.log(`app.$axios.post("/api/auth/login") =>`, error.response?.data?.message || error);
                    // }

                    // Cookies.set("XSRF-TOKEN", data.token, {
                    //     path: "/",
                    //     secure: true,
                    //     sameSite: "lax",
                    // });
                    // await $auth.fetchUser();
                }
            } catch (error) {
                console.error("Offline auth failed:", error);
            }
            return redirect("/lk/");
        }
        // избранное не редиректим
        if (!ALLOW_ROUTES.includes(route.path) && route.path.includes("/lk/") && route.path !== "/lk/favorites/") {
            return redirect("/lk/login/");
        }
    }
}
